import styled from 'styled-components';

const StyledSemiboldLabel = styled.strong`
  font-weight: ${(props) => props.theme.fonts.fontWeights.demi};
`;

export default StyledSemiboldLabel;
